import apiAxios from "./axiosConfig";

export const loginCall = async (credentials: {
  email: string;
  password: string;
}) => {
  const response = await apiAxios.post("auth/login", credentials);
  return response;
};
